// extracted by mini-css-extract-plugin
export default {"header":"styles_header__m+w9b","logo":"styles_logo__ayyZ2","body":"styles_body__BygYo","button":"styles_button__gfxI1","books":"styles_books__oAhAZ","book":"styles_book__z7Iwn"};